import React from "react";

const AboutMe = () => {
  return (
    <div className="min-h-screen w-full ">
      <div className="aboutBody px-10 py-20">
        <div
          className="introBody  "
          data-aos="zoom-in"
          data-aos-duration="1500"
        >
          <h1 className="text-5xl text-white font-extrabold uppercase mb-20">
            about
            <span className="text-primary"> ME</span>
          </h1>

          {/* about me intro content */}

          <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12 md:col-span-8  lg:col-span-8 ">
              <h2 className="text-5xl font-bold py-3">
                Hi,I am{" "}
                <span className="text-primary">Mahamodul Hasan Moon</span>
              </h2>
              <h2 className="text-3xl font-semibold py-3">
                MERN Stack Developer
              </h2>

              <p className="text-secondaryWhite text-justify">
                Hi there! My name is Mahamodul Hasan and I am a MERN Stack
                Developer. I have experience in using the MERN stack, which
                consists of MongoDB, Express, React, and Node.js, to build web
                applications. With my skills in HTML, CSS, and JavaScript, I am
                able to design and develop the front-end of web applications, as
                well as implement dynamic and interactive features using these
                technologies. I am a proactive learner and am currently
                exploring the React framework to expand my skills and knowledge
                in this area.
              </p>
              <br />
              <p className="text-secondaryWhite text-justify">
                As a MERN Stack Developer, I am passionate about creating
                intuitive and responsive web applications that provide a
                seamless user experience. I enjoy the process of taking an idea
                and turning it into a functional and visually appealing
                application. I am always looking for ways to improve and enhance
                my skills, and I am excited to bring my expertise and creativity
                to new projects and challenges.
              </p>
            </div>
            <div className="col-span-12 md:col-span-4 lg:col-span-4">
              <ul>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Name: Mahamodul Hasan Moon
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Email: coddermoon@gmail.com
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Phone: +8801771517322
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Nationality: Bangladeshi
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Languages: English , Bangla
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    From : Netrakona, Bangladesh
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    skills : JavaScript , Reactjs , ExpressJS, MongoDB, NodeJS,
                    TypeScript, php{" "}
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Experience : 1.5 years
                  </p>
                </li>
                <li>
                  <p className="text-[#ddd] border-b-2 border-primary pb-2 pt-4 text-lg font-medium">
                    Freelance : Available
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
